import { ToastrService } from 'ngx-toastr';
import { HttpResponse } from '@angular/common/http';
import { Component, Input, Output, EventEmitter, OnDestroy, SimpleChanges, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { FileDownloadService } from '@services/file-download.service';
import { FilenameParser } from '@utils/FilenameParser';
import { catchError, exhaustMap, filter, take } from 'rxjs/operators';
import { UploadFileService } from 'src/app/services/upload-file.service';
import { interval, of, Subscription } from 'rxjs';
import { LoginService } from '@services/login.service';
import { GoogleComponent } from '@pages/utils/google.component';
import { GoogleTagManagerEventEnum } from 'src/app/enums/GoogleTagManagerEvent.enum';
import { AlertErroCustomizadoComponent } from '../alert-erro-customizado/alert-erro-customizado.component';
import { AlertLoadingComponent } from '../alert-loading/alert-loading.component';
import { NgClass } from '@angular/common';
import { TagManagerDirective } from '../../directives/tag-manager.directive';
import { RouterLink } from '@angular/router';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { CnpjPipe } from '../../pipes/cnpj.pipe';

@Component({
    selector: 'app-alert-resumo-importacao',
    templateUrl: './alert-resumo-importacao.component.html',
    styleUrls: ['./alert-resumo-importacao.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AlertErroCustomizadoComponent, AlertLoadingComponent, NgClass, TagManagerDirective, RouterLink, PopoverDirective, CnpjPipe]
})
export class AlertResumoImportacaoComponent extends GoogleComponent implements OnDestroy, OnChanges {

  @Input() alertResumoImportacao: boolean = false;
  @Input() resumoImportacao: any = false;
  @Input() sourceScreen: string = '';
  @Input() screenType: string = '';
  @Output() alertResumoImportacaoFechou = new EventEmitter();

  subscriptions: Array<Subscription> = [];
  idImportacao = localStorage.getItem('idImportacao');

  public statusUploadApi = 0;
  public statusFaseApi: any;
  public showModal: 'AlertLoading' | '' = '';
  alertErroImportacao: boolean;
  botaoErroImportacao: string;
  tituloMensagemErroImportacao: string;
  mensagemErroImportacao: string;
  sucessoStatusImportacao: any;
  necessarioBaixarRelatorio: boolean;
  baixouRelatorio: boolean;

  constructor(
    private readonly service: UploadFileService,
    private readonly Toastr: ToastrService,
    private readonly serviceResumoImportacao: UploadFileService,
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.alertResumoImportacao?.currentValue && this.sourceScreen !== '') {
      const model = this.buildTagFromSourceScreen(GoogleTagManagerEventEnum.screenView, null, null, this.sourceScreen, this.screenType);
      this.tagManagerService.pushTag(model);
    }
    if (changes && this.alertResumoImportacao === true) {
      if (!this.baixouRelatorio) {
        this.necessarioBaixarRelatorio = this.resumoImportacao.hasInconsistencies;
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  addTagManagerInteraction(elementType: string, elementContent: string) {
    return this.buildTagFromSourceScreen(GoogleTagManagerEventEnum.interaction, elementType, elementContent, this.sourceScreen, this.screenType);
  }

  async fecharAlertResumoImportacao(acao: string) {
    localStorage.removeItem('tratativas');
    this.baixouRelatorio = false;
    this.subscriptions.forEach(s => s.unsubscribe());
    if (acao !== 'cancelar') {
      await this.consultaStatusImportacao();
      if (this.sucessoStatusImportacao === true) {
        this.alertResumoImportacaoFechou.emit('sucesso');
      }
    }
    this.alertResumoImportacaoFechou.emit(acao);
  }

  public baixarRelatorio() {
    this.necessarioBaixarRelatorio = false;
    this.baixouRelatorio = true;
    this.service.getDownloadInconsistencias(localStorage.getItem('idImportacao'))
      .pipe(take(1))
      .subscribe({
        next: ({ body, headers }: HttpResponse<any>) => {
          const filename = FilenameParser.fromContentDispositionHeader(headers.get('content-disposition'), 'Arquivo.csv');
          FileDownloadService.download([body], filename);
        },
        error: (error) => {
          this.Toastr.error(error.error.mensagem, '', { timeOut: 2000 });
        }
      });
  }

  consultaStatusImportacao() {
    return new Promise<void>(resolve => {
      this.showModal = 'AlertLoading';
      const subscription = interval(3000)
        .pipe(
          exhaustMap(() => this.serviceResumoImportacao
            .recuperarStatusImportacao(localStorage.getItem('idImportacao'))
            .pipe(catchError(() => of()))
          ),
        )
        .subscribe({
          next: (response: any) => {
            this.statusUploadApi = response.quantidadePorcentagemFase;
            if (response.quantidadePorcentagemFase === 100) {
              this.showModal = '';
              subscription.unsubscribe();
              logoutSubscription.unsubscribe();
              resolve();
              if (response.descricaoFase !== 'RESUMO DE PROBLEMAS') {
                this.sucessoStatusImportacao = true;
              }
            }
          },
          error: () => {
            this.tituloMensagemErroImportacao = 'Ocorreu um erro durante a importação!';
            this.mensagemErroImportacao = 'Favor verificar o arquivo e tentar novamente!';
            this.botaoErroImportacao = 'Cancelar importação';
            this.alertErroImportacao = true;
          }
        });

      this.subscriptions.push(subscription);
      const logoutSubscription = LoginService.events$
        .pipe(filter(event => event.type === 'logout'))
        .subscribe(() => {
          subscription.unsubscribe();
          logoutSubscription.unsubscribe();
          resolve();
          this.showModal = '';
        });
      this.subscriptions.push(logoutSubscription);
    });
  }

  fecharAlertErroImportacao() {
    this.fecharAlertResumoImportacao('cancelar');
    this.alertErroImportacao = false;
  }
}
